var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.auth.user_status_id==2)?_c('Churchportal'):_vm._e(),(_vm.$store.state.auth.user_status_id==1)?_c('Adminportal'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }